import React, { useState, useContext } from 'react'
import { appContext } from '../../../../../../App'
import AdminConfig from './AdminConfig'
import { countries, time_zones } from '../../../../../utilities/utilities'
import { saveClient } from '../../NPOSAccountFunctions'

export const adminConfigControllerContext = React.createContext()

function useAdminConfigController(props) {
  const app = useContext(appContext)
  const [client, setClient] = useState({ ...app.client })

  const updateClient = async (_client) => {
    let _client_ = _client ?? client

    const saved_client = await saveClient(app, _client_)
    // If there's no error then resetClient (set to updated client)
    if (!saved_client.error) {
      /** Update the Global Client (app.client) */
      app.resetClient(saved_client)

      /** Local Client */
      setClient({ ...saved_client })
    }

    return saved_client
  }

  return ({
    client: [client, setClient],
    updateClient,
    app_client: app.client,
    countries, time_zones
  })
}

function AdminConfigController(props) {
  const adminConfigController = useAdminConfigController(props)
  return (
    <React.Fragment>
      <adminConfigControllerContext.Provider value={adminConfigController}>
        <AdminConfig />
      </adminConfigControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(AdminConfigController)